"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Spaceways = void 0;
const CardName_1 = require("../../../CardName");
const CardType_1 = require("../../CardType");
const CardRenderer_1 = require("../../render/CardRenderer");
const Size_1 = require("../../render/Size");
const Card_1 = require("../../Card");
const Tags_1 = require("../../Tags");
const Resources_1 = require("../../../Resources");
class Spaceways extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.CORPORATION,
            name: CardName_1.CardName.SPACEWAYS,
            tags: [Tags_1.Tags.SPACE],
            startingMegaCredits: 42,
            metadata: {
                cardNumber: 'R55',
                description: 'You start with 42 M€ and 2 titanium.',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.megacredits(42).titanium(2);
                    b.corpBox('effect', (ce) => {
                        ce.vSpace(Size_1.Size.LARGE);
                        ce.effect(undefined, (eb) => {
                            eb.space().played.any.nbsp(Size_1.Size.SMALL).event().played.any.nbsp(Size_1.Size.TINY).startEffect;
                            eb.megacredits(2);
                        });
                        ce.vSpace();
                        ce.effect('When any player plays a Space Event, gain 2 M€. When you play a Space Event, increase your M€ production 1 step.', (eb) => {
                            eb.space().played.event().played.startEffect;
                            eb.production((pb) => pb.megacredits(1));
                        });
                        ce.vSpace(Size_1.Size.SMALL);
                    });
                }),
            },
        });
    }
    play(player) {
        player.addResource(Resources_1.Resources.TITANIUM, 2);
        return undefined;
    }
    onCardPlayed(player, card) {
        const corpOwner = player.game.getCardPlayer(this.name);
        if (card.cardType === CardType_1.CardType.EVENT && card.tags.includes(Tags_1.Tags.SPACE)) {
            corpOwner.addResource(Resources_1.Resources.MEGACREDITS, 2, { log: true });
            if (player.id === corpOwner.id) {
                corpOwner.addProduction(Resources_1.Resources.MEGACREDITS, 1);
            }
        }
    }
}
exports.Spaceways = Spaceways;
//# sourceMappingURL=Spaceways.js.map